import { render, staticRenderFns } from "./ReleaseDetails.vue?vue&type=template&id=4746b01c&scoped=true&"
import script from "./ReleaseDetails.vue?vue&type=script&lang=ts&"
export * from "./ReleaseDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ReleaseDetails.vue?vue&type=style&index=0&id=4746b01c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4746b01c",
  null
  
)

export default component.exports